import { frontendURL } from '../../../../helper/URLHelper';
import {
  EVERY_USER_PERMISSIONS,
  GOOGLE_CALENDAR_ROUTE_PERMISSIONS,
  GOOGLE_SHEETS_ROUTE_PERMISSIONS,
} from './integrationAccess';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const IntegrationHooks = () => import('./IntegrationHooks.vue');
const Index = () => import('./Index.vue');
const Webhook = () => import('./Webhooks/Index.vue');
const DashboardApps = () => import('./DashboardApps/Index.vue');
const GoogleSheets = () => import('./GoogleSheets.vue');
const GoogleCalendar = () => import('./GoogleCalendar.vue');
const SettingsContent = () => import('../Wrapper.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          // Aberta a todo usuário desde a #586: o não-administrador vê só os cards que pode
          // abrir (visibleIntegrations), hoje a própria Google Agenda e, com permissão, o Sheets.
          meta: {
            permissions: EVERY_USER_PERMISSIONS,
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_integrations';
        const backUrl =
          params.name === 'settings_integrations_integration'
            ? { name: 'settings_integrations' }
            : '';
        return {
          headerTitle: 'INTEGRATION_SETTINGS.HEADER',
          icon: 'flash-on',
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: 'google_sheets',
          name: 'settings_integrations_google_sheets',
          component: GoogleSheets,
          meta: {
            permissions: GOOGLE_SHEETS_ROUTE_PERMISSIONS,
          },
        },
        {
          path: 'google_calendar',
          name: 'settings_integrations_google_calendar',
          component: GoogleCalendar,
          meta: {
            permissions: GOOGLE_CALENDAR_ROUTE_PERMISSIONS,
          },
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
